import { projectClient } from '../../client/client';

export const developer = {
  list: projectClient('/developer').get,
  get: projectClient('/developer/{id}').get,
  delete: projectClient('/developer/{id}').delete,
  update: projectClient('/developer/{id}').patch,
  invite: projectClient('/developer/invite').post,
  listV2: projectClient('/developer/v2/list').get,
};
